module.exports = __webpack_public_path__ + "img/iPhone-hotel-bot.2364a9e0.webp";